var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('mq-layout',{attrs:{"mq":"mobile"}},[_c('GridMobile')],1),_c('mq-layout',{staticClass:"ml-12 pl-5 pr-4",attrs:{"mq":"desktop"}},[_c('Header'),_c('Grid')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }